import React, { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { CheckCircle2 } from "lucide-react";
import { fetchOrderStatus, formatCAD } from "../lib/api";
import { useStore } from "../context/StoreContext";
import { Button } from "../components/ui/button";

export default function OrderSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { clearCart } = useStore();

  useEffect(() => {
    clearCart();
  }, [clearCart]);

  const { data, isLoading, isError } = useQuery({
    queryKey: ["order-status", sessionId],
    queryFn: () => fetchOrderStatus({ session_id: sessionId }),
    enabled: Boolean(sessionId),
    refetchInterval: (q) => (q.state.data?.status === "paid" ? false : 2000),
  });

  return (
    <div className="max-w-2xl mx-auto px-4 py-16 text-center">
      <div className="mx-auto h-16 w-16 rounded-full bg-emerald-100 flex items-center justify-center mb-6">
        <CheckCircle2 className="h-9 w-9 text-emerald-600" />
      </div>
      <h1 className="text-3xl font-bold text-slate-900">Merci pour votre commande</h1>
      <p className="text-muted-foreground mt-3">
        {isLoading && "Confirmation du paiement en cours…"}
        {isError && "Paiement reçu. La fiche commande se mettra à jour sous peu."}
        {data?.status === "paid" && "Votre paiement a été confirmé."}
        {data && data.status !== "paid" && "Paiement en cours de confirmation…"}
      </p>
      {data && (
        <div className="mt-8 text-left bg-white border border-border rounded-xl p-6 space-y-3">
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">N° commande</span>
            <span className="font-semibold">{data.order_number}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Statut</span>
            <span className="font-medium capitalize">{data.status}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Total</span>
            <span className="font-bold">{formatCAD((data.total_cents || 0) / 100)}</span>
          </div>
          {Array.isArray(data.items) && data.items.length > 0 && (
            <ul className="border-t border-border pt-3 space-y-2">
              {data.items.map((it, i) => (
                <li key={i} className="flex justify-between text-sm gap-3">
                  <span className="text-slate-700 line-clamp-1">
                    {it.product_name} × {it.quantity}
                  </span>
                  <span>{formatCAD((it.unit_price_cents * it.quantity) / 100)}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
      <Link to="/boutique">
        <Button className="mt-8 rounded-full bg-brand-orange hover:bg-orange-600">
          Continuer vos achats
        </Button>
      </Link>
    </div>
  );
}
